import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const BannerSection = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const [banners, setBanners] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  // Inject smooth marquee animation
  useEffect(() => {
    const styleEl = document.createElement("style");
    styleEl.innerHTML = `
      @keyframes smoothMarquee {
        0% { transform: translateX(100%); }
        100% { transform: translateX(-100%); }
      }
    `;
    document.head.appendChild(styleEl);
    return () => {
      document.head.removeChild(styleEl);
    };
  }, []);

  // Preload next banner image
  useEffect(() => {
    if (banners.length > 0) {
      const nextIndex = currentIndex === banners.length - 1 ? 0 : currentIndex + 1;
      const nextBanner = banners[nextIndex];
      if (nextBanner?.banner?.full_size) {
        const img = new Image();
        img.src = nextBanner.banner.full_size;
      }
    }
  }, [currentIndex, banners]);
  
  // Fetch banners
  useEffect(() => {
    if (!token) {
      navigate("/login");
      return;
    }

    const fetchBanners = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/api/banners/`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Token ${token}`,
            },
          }
        );
        const data = await response.json();
        const validBanners = data.filter(
          (b) => b?.banner?.full_size || b?.text || b?.message
        );
        setBanners(validBanners);
      } catch (error) {
        console.error("Error fetching banners:", error);
      }
    };
    fetchBanners();
  }, [token, navigate]);

  // Rotate image banners
  useEffect(() => {
    if (!banners.length) return;
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === banners.length - 1 ? 0 : prevIndex + 1
      );
    }, 5000);
    return () => clearInterval(interval);
  }, [banners]);

  // Track banner views
  useEffect(() => {
    if (!banners.length || !window.gtag) return;
  
    const currentBanner = banners[currentIndex];
    const rawBannerName = currentBanner?.text || currentBanner?.id || "Unknown";
    const bannerName = rawBannerName.replace(/\s+/g, "_").toLowerCase();
  
    try {
      window.gtag("event", `banner_${bannerName}_view`, {
        banner_name: rawBannerName,
        banner_id: currentBanner?.id || "unknown",
        banner_position: currentIndex,
      });
    } catch (err) {
      console.error("GTAG banner view event failed:", err);
    }
  }, [currentIndex, banners]);
  

  // // Track banner views
  // useEffect(() => {
  //   if (!banners.length || !window.gtag) return;
  //   const currentBanner = banners[currentIndex];
  //   const bannerName = currentBanner?.text || currentBanner?.id || "Unknown";
  //     window.gtag("event", `banner_${bannerName}_view`, {
  //       banner_name: bannerName,
  //       banner_id: currentBanner?.id || "unknown",
  //       banner_position: currentIndex,
  //     });
  //   }
  // //   window.gtag("event", "banner_view", {
  // //     banner_name: `Banner: ${bannerName}`,
  // //     // banner_name: `Banner: ${currentBanner?.text || currentBanner?.id || "Unknown"}`,
  // //     banner_id: currentBanner?.id || "unknown",
  // //     banner_position: currentIndex,
  // //     dimension1: bannerName, // 
  // //   });
  // // }, [currentIndex, banners]);
    
  
  const handleBannerClick = (banner) => {
    if (!window.gtag) return;
  
    const rawBannerName = banner?.text || banner?.id || "Unknown";
    const bannerName = rawBannerName.replace(/\s+/g, "_").toLowerCase(); // sanitize name
  
    console.log("Banner clicked, sending GA event:", banner);
  
    window.gtag("event", `banner_${bannerName}_click`, {
      banner_name: rawBannerName,
      banner_id: banner?.id || "unknown",
      banner_url: banner?.url || "#",
      banner_position: currentIndex,
    });
  };
  
  

  // Handle message click with proper tracking
  const handleMessageClick = (message) => {
    if (!window.gtag) return;
      
    window.gtag("event", "banner_message_click", {
      message_name: `Message: ${message.message || "Unknown"}`,
      message_id: message.id || "unknown",
      message_url: message.url || "#",
    });
    
    // Open the URL if available
    if (message.url) {
      window.open(message.url, "_blank", "noopener,noreferrer");
    }
  };

  // Collect all messages from banners
  const messages = banners
    .filter((b) => b?.message)
    .map((b) => ({ id: b.id, message: b.message, url: b.url }));

  if (!banners.length) return null;
  const currentBanner = banners[currentIndex];
  const isImageBanner = currentBanner?.banner?.full_size ? true : false;

  return (
    <div>
      {/* Marquee section for all messages */}
      {messages.length > 0 && (
        <div
          style={{
            overflow: "hidden",
            background: "#f8f9fa",
            margin: "10px 0",
            border: "1px solid #e9ecef",
            borderRadius: "4px",
            position: "relative",
            height: "40px",
          }}
        >
          <div
            style={{
              display: "inline-block",
              whiteSpace: "nowrap",
              willChange: "transform",
              animation: "smoothMarquee 20s linear infinite",
              fontSize: "24px",
              color: "red",
              fontWeight: "bold",
            }}
          >
            {messages.map((message, index) => (
              <span 
                key={index} 
                style={{ 
                  marginRight: "50px",
                  cursor: message.url ? "pointer" : "default" 
                }}
                onClick={() => message.url ? handleMessageClick(message) : null}
              >
                {message.message}
              </span>
            ))}
          </div>
        </div>
      )}

      {/* Rotating image banner below marquee */}
      {isImageBanner && (
        <a
          href={currentBanner?.url || "#"}
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => {
            e.preventDefault(); // Prevent default to ensure tracking happens before navigation
            handleBannerClick(currentBanner);
            // Navigate after a small delay to ensure tracking completes
            if (currentBanner?.url) {
              setTimeout(() => {
                window.open(currentBanner.url, "_blank", "noopener,noreferrer");
              }, 100);
            }
          }}
        >
          <img
            src={currentBanner.banner.full_size}
            alt={currentBanner?.text || currentBanner?.message || "Banner"}
            style={{ width: "75%", height: "auto" }}
            // style={{ width: "75%", height: "auto", margin: "0 auto" }}
          />
        </a>
      )}
    </div>
  );
};

export default BannerSection;